import { ICreateInformacaoFaturamentoUseCase } from "../../../presentation/useCases/create/create_informacao_faturamento_use_case";
import { InformacaoFaturamento } from "../../models/informacao_faturamento";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateinformacaoFaturamentoUseCase
 */

export class CreateInformacaoFaturamentoUseCase implements ICreateInformacaoFaturamentoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async createInformacaoFaturamento(form: InformacaoFaturamento): Promise<InformacaoFaturamento> {
    const result = await this.repository.createInformacaoFaturamento(form)
    return result;
  }

}
